module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-business-cards-400x284-3e3ec1a03b24b463ecc282f098e9ed5a.png";